module.exports = __webpack_public_path__ + "img/catG.efecb936.svg";